import { render, staticRenderFns } from "./Flashcard.vue?vue&type=template&id=2aa744dd&scoped=true&"
import script from "./Flashcard.vue?vue&type=script&lang=js&"
export * from "./Flashcard.vue?vue&type=script&lang=js&"
import style0 from "./Flashcard.vue?vue&type=style&index=0&id=2aa744dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa744dd",
  null
  
)

export default component.exports